import {CommonModule} from '@angular/common';
import {Component, inject, OnInit} from '@angular/core';
import {APP_ROUTES} from '@app/constants';
import {AuthService} from '@app/core/auth';
import {MenuItem} from 'primeng/api';
import {AvatarModule} from 'primeng/avatar';
import {MenuModule} from 'primeng/menu';

@Component({
  selector: 'app-sidebar-bottom',

  imports: [MenuModule, AvatarModule, CommonModule],
  templateUrl: './sidebar-bottom.component.html',
  styleUrl: './sidebar-bottom.component.css',
})
export class SidebarBottomComponent implements OnInit {
  private authService = inject(AuthService);

  userName = "";

  items: MenuItem[] = [
    {
      items: [
        {
          label: 'Profile',
          icon: 'pi pi-user',
          routerLink: [APP_ROUTES.USER_PROFILE],
        },
       /* {
          label: 'Change Password',
          icon: 'pi pi-key',
          routerLink: [APP_ROUTES.USER_PROFILE],
        },*/
        {
          label: 'Logout',
          icon: 'pi pi-sign-out',
          routerLink: [APP_ROUTES.LOGOUT],
        },
      ],
    },
  ];

  ngOnInit() {
    this.authService.user$.subscribe((user) => {
      this.userName = user.username;
    });
  }
}
